import { observer } from 'mobx-react-lite';
import { useListStore } from "..";
import { useConditionallyClosable } from '../hooks/useClosable';
import ListType from "../interfaces/ListType";
import { ClosableOrder } from '../store/ClosableStore';
import Companies from "./companies/Companies";
import Deals from "./deals/Deals";
import Favorites from "./favorites/Favorites";
import Leads from "./leads/Leads";
import LeaseComps from "./leaseComps/LeaseComps";
import Notifications from "./notifications/Notifications";
import SaleComps from "./saleComps/SaleComps";
import TenantsInMarket from "./tenantsInMarket/TenantsInMarket";

function ListController() {
    const listStore = useListStore();
    useConditionallyClosable(ClosableOrder.Low, () => listStore.close(), !!listStore.type);

    if (!listStore.type)
        return null;

    switch (listStore.type) {
        case ListType.Deals: return <Deals />;
        case ListType.Leads: return <Leads />;
        case ListType.LeaseComps: return <LeaseComps />;
        case ListType.SaleComps: return <SaleComps />;
        case ListType.Companies: return <Companies />;
        case ListType.TenantsInMarket: return <TenantsInMarket />;
        case ListType.Favorites: return <Favorites />;
        case ListType.Notifications: return <Notifications />;
    }
}

export default observer(ListController);